import { render } from "./monthlysub.vue?vue&type=template&id=47c3e5a1"
import script from "./monthlysub.vue?vue&type=script&lang=js"
export * from "./monthlysub.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__